
{
  "familyId": "TIJD-PLANNING",
  "questions": [
    {
      "id": "TIJD-PLANNING-001",
      "familyId": "TIJD-PLANNING",
      "module": "Tijd",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "tijdrekenen",
      "subSkill": "tijd_planning",
      "questionType": "multiple_choice",
      "question": "Je moet om 15:00 op school zijn. De reis duurt 25 minuten. Hoe laat moet je vertrekken?",
      "options": ["14:35", "14:25", "15:25", "14:45"],
      "correctAnswer": 0,
      "conceptId": "time_planning_backward",
      "variantIndex": 1,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.76,
      "stimulusAids": [
        {
          "type": "digitalClock",
          "data": { "hours": 15, "minutes": 0, "format": "24h", "label": "Aankomsttijd school" },
          "a11y": { "alt": "Digitale klok toont 15:00, de aankomsttijd op school" }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Terugrekenen vanaf aankomsttijd",
            "content": "Je moet om 15:00 aankomen. Trek de reistijd af: 15:00 − 25 minuten = 14:35. Je moet om 14:35 vertrekken.",
            "icon": "lightbulb"
          }
        }
      ],
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "tijd.minutes-subtraction-error", "label": "Verkeerd aantal minuten afgetrokken (te veel)", "optionIndex": 1 },
          { "id": "tijd.add-instead-of-subtract", "label": "Optellen i.p.v. aftrekken bij terugrekenen", "optionIndex": 2 },
          { "id": "tijd.minutes-subtraction-error", "label": "Verkeerd aantal minuten afgetrokken (te weinig)", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "Als je op een bepaalde tijd moet aankomen, reken je terug door de reistijd af te trekken van de aankomsttijd. 15:00 − 25 minuten = 14:35. Je moet om 14:35 vertrekken.",
        "solutionSteps": ["Aankomsttijd: 15:00", "Trek de reistijd af: 15:00 − 25 minuten", "15:00 − 25 min = 14:35"],
        "distractorExplanations": {
          "0": "Goed! 15:00 − 25 minuten = 14:35.",
          "1": "Je dacht waarschijnlijk dat je 35 minuten moest aftrekken in plaats van 25. Maar de reistijd is 25 minuten: 15:00 − 25 = 14:35, niet 14:25. Onthoud: lees de reistijd goed en trek precies dat aantal af.",
          "2": "Je dacht waarschijnlijk dat je de reistijd erbij moest tellen. Maar je moet eerder vertrekken, niet later: trek de reistijd af van de aankomsttijd. Onthoud: terugrekenen = aftrekken.",
          "3": "Je dacht waarschijnlijk dat je maar 15 minuten hoefde af te trekken. Maar de reistijd is 25 minuten: 15:00 − 25 = 14:35, niet 14:45. Onthoud: controleer door op te tellen: 14:35 + 25 min = 15:00 ✓."
        }
      }
    },
    {
      "id": "TIJD-PLANNING-002",
      "familyId": "TIJD-PLANNING",
      "module": "Tijd",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "tijdrekenen",
      "subSkill": "tijd_planning",
      "questionType": "multiple_choice",
      "question": "Je vertrekt om 13:40 van huis. De reis naar de bioscoop duurt 35 minuten. Hoe laat kom je aan?",
      "options": ["14:15", "13:75", "14:05", "14:25"],
      "correctAnswer": 0,
      "conceptId": "time_planning_forward",
      "variantIndex": 2,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.74,
      "stimulusAids": [
        {
          "type": "digitalClock",
          "data": { "hours": 13, "minutes": 40, "format": "24h", "label": "Vertrektijd" },
          "a11y": { "alt": "Digitale klok toont 13:40, de vertrektijd van huis" }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Vooruit rekenen met minuten",
            "content": "Vertrek: 13:40. Tel de reistijd erbij: 13:40 + 35 minuten. Reken: 40 + 35 = 75 minuten = 1 uur en 15 minuten. 13:40 + 1:15 = 14:15.",
            "icon": "lightbulb"
          }
        }
      ],
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "tijd.overflow-notation-error", "label": "Minuten boven 60 direct achter dubbele punt geschreven", "optionIndex": 1 },
          { "id": "tijd.minutes-addition-error", "label": "Verkeerd aantal minuten opgeteld (te weinig)", "optionIndex": 2 },
          { "id": "tijd.minutes-addition-error", "label": "Verkeerd aantal minuten opgeteld (te veel)", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "Tel de reistijd bij de vertrektijd op. 13:40 + 35 minuten: 40 + 35 = 75 minuten. Omdat 75 minuten meer is dan 60, reken je om: 75 minuten = 1 uur en 15 minuten. 13:40 + 1:15 = 14:15.",
        "solutionSteps": ["Vertrektijd: 13:40", "Tel de reistijd erbij: 40 + 35 = 75 minuten", "75 minuten = 1 uur en 15 minuten", "13:40 + 1:15 = 14:15"],
        "distractorExplanations": {
          "0": "Goed! 13:40 + 35 minuten = 14:15.",
          "1": "Je dacht waarschijnlijk dat je gewoon 40 + 35 = 75 achter de dubbele punt kunt schrijven. Maar 13:75 bestaat niet — een uur heeft maar 60 minuten. Onthoud: als je boven 60 minuten komt, reken je om naar uren: 75 min = 1 uur en 15 min.",
          "2": "Je dacht waarschijnlijk dat je 25 minuten moest optellen in plaats van 35. Maar de reistijd is 35 minuten: 13:40 + 35 = 14:15, niet 14:05. Onthoud: lees de reistijd goed.",
          "3": "Je dacht waarschijnlijk dat je 45 minuten moest optellen in plaats van 35. Maar de reistijd is 35 minuten: 13:40 + 35 = 14:15, niet 14:25. Onthoud: controleer door terug te rekenen: 14:15 − 35 min = 13:40 ✓."
        }
      }
    },
    {
      "id": "TIJD-PLANNING-003",
      "familyId": "TIJD-PLANNING",
      "module": "Tijd",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "tijdrekenen",
      "subSkill": "tijd_planning",
      "questionType": "multiple_choice",
      "question": "De bus vertrekt om 08:15. Je wilt 10 minuten voor vertrek op het busstation zijn. Hoe laat moet je daar zijn?",
      "options": ["08:05", "08:10", "08:25", "07:05"],
      "correctAnswer": 0,
      "conceptId": "time_planning_buffer",
      "variantIndex": 3,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.78,
      "stimulusAids": [
        {
          "type": "digitalClock",
          "data": { "hours": 8, "minutes": 15, "format": "24h", "label": "Vertrektijd bus" },
          "a11y": { "alt": "Digitale klok toont 08:15, de vertrektijd van de bus" }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Buffer tijd inplannen",
            "content": "Bus vertrekt: 08:15. Je wilt 10 minuten eerder zijn. Trek 10 minuten af: 08:15 − 10 minuten = 08:05.",
            "icon": "lightbulb"
          }
        }
      ],
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "tijd.minutes-subtraction-error", "label": "Te weinig minuten afgetrokken", "optionIndex": 1 },
          { "id": "tijd.add-instead-of-subtract", "label": "Optellen i.p.v. aftrekken bij 'eerder zijn'", "optionIndex": 2 },
          { "id": "tijd.full-hour-instead-of-minutes", "label": "Heel uur i.p.v. minuten afgetrokken", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "Als je eerder wilt zijn dan de vertrektijd, trek je de buffertijd af. De bus vertrekt om 08:15 en je wilt 10 minuten eerder zijn: 08:15 − 10 minuten = 08:05.",
        "solutionSteps": ["Vertrektijd bus: 08:15", "Je wilt 10 minuten eerder zijn", "08:15 − 10 min = 08:05"],
        "distractorExplanations": {
          "0": "Goed! 08:15 − 10 minuten = 08:05.",
          "1": "Je dacht waarschijnlijk dat je maar 5 minuten hoefde af te trekken. Maar je wilt 10 minuten eerder zijn: 08:15 − 10 = 08:05, niet 08:10. Onthoud: lees goed hoeveel minuten eerder je wilt zijn.",
          "2": "Je dacht waarschijnlijk dat je de 10 minuten erbij moest tellen. Maar je wilt eerder zijn, niet later: trek de buffertijd af. Onthoud: 'eerder zijn' = aftrekken, niet optellen.",
          "3": "Je dacht waarschijnlijk dat je een heel uur moest aftrekken. Maar je trekt 10 minuten af, niet 1 uur en 10 minuten: 08:15 − 10 min = 08:05, niet 07:05. Onthoud: trek alleen de buffertijd af."
        }
      }
    },
    {
      "id": "TIJD-PLANNING-004",
      "familyId": "TIJD-PLANNING",
      "module": "Tijd",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "tijdrekenen",
      "subSkill": "tijd_planning",
      "questionType": "multiple_choice",
      "question": "Je afspraak is om 16:30. Je wilt er 15 minuten voor aankomst zijn en de reis duurt 40 minuten. Hoe laat vertrek je?",
      "options": ["15:35", "15:50", "15:45", "16:15"],
      "correctAnswer": 0,
      "conceptId": "time_planning_complex",
      "variantIndex": 4,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.72,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Meerdere stappen terugrekenen",
            "content": "Afspraak: 16:30. Eerst 15 minuten eerder: 16:30 − 15 min = 16:15. Dan de reistijd: 16:15 − 40 min = 15:35. Je vertrekt om 15:35.",
            "icon": "lightbulb"
          }
        },
        {
          "type": "timeline",
          "showWhen": "wrong",
          "data": {
            "label": "Plannings-tijdlijn",
            "events": [
              { "position": 15.583, "label": "15:35", "description": "Vertrek", "isHighlighted": true },
              { "position": 16.25, "label": "16:15", "description": "Aankomst", "isHighlighted": true },
              { "position": 16.5, "label": "16:30", "description": "Afspraak", "isHighlighted": true }
            ],
            "start": 15.5,
            "end": 16.75
          },
          "a11y": { "alt": "Tijdlijn van vertrek 15:35 → aankomst 16:15 → afspraak 16:30" }
        }
      ],
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "tijd.buffer-time-forgotten", "label": "Alleen reistijd afgetrokken, buffertijd vergeten", "optionIndex": 1 },
          { "id": "tijd.minutes-subtraction-error", "label": "Optelsom van stappen verkeerd berekend", "optionIndex": 2 },
          { "id": "tijd.minutes-subtraction-error", "label": "Alleen buffertijd afgetrokken, reistijd vergeten", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "Bij meerdere stappen reken je stap voor stap terug. Eerst trek je de buffertijd af: 16:30 − 15 min = 16:15. Dan trek je de reistijd af: 16:15 − 40 min = 15:35. Je vertrekt om 15:35.",
        "solutionSteps": ["Afspraaktijd: 16:30", "Trek buffertijd af: 16:30 − 15 min = 16:15", "Trek reistijd af: 16:15 − 40 min = 15:35", "Je vertrekt om 15:35"],
        "distractorExplanations": {
          "0": "Goed! 16:30 − 15 min = 16:15, dan 16:15 − 40 min = 15:35.",
          "1": "Je dacht waarschijnlijk dat je alleen de reistijd hoefde af te trekken. Maar je vergeet de 15 minuten buffertijd: 16:30 − 15 − 40 = 15:35, niet 15:50. Onthoud: trek zowel de buffertijd als de reistijd af.",
          "2": "Je dacht waarschijnlijk dat 15 + 40 = 55 minuten, en trok dat af als 16:30 − 55 = 15:45. Maar 16:30 − 55 min = 15:35, niet 15:45. Onthoud: 30 − 55 = −25, dus 16:30 − 55 = 15 uur en 35 min.",
          "3": "Je dacht waarschijnlijk dat je alleen de buffertijd hoefde af te trekken. Maar je vergeet de 40 minuten reistijd: 16:30 − 15 − 40 = 15:35, niet 16:15. Onthoud: trek zowel de buffertijd als de reistijd af."
        }
      }
    },
    {
      "id": "TIJD-PLANNING-005",
      "familyId": "TIJD-PLANNING",
      "module": "Tijd",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "tijdrekenen",
      "subSkill": "tijd_planning",
      "questionType": "multiple_choice",
      "question": "Je vertrekt om 10:50 en de reis duurt 1 uur en 20 minuten. Hoe laat kom je aan?",
      "options": ["12:10", "11:10", "12:20", "11:70"],
      "correctAnswer": 0,
      "conceptId": "time_planning_long",
      "variantIndex": 5,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.74,
      "stimulusAids": [
        {
          "type": "digitalClock",
          "data": { "hours": 10, "minutes": 50, "format": "24h", "label": "Vertrektijd" },
          "a11y": { "alt": "Digitale klok toont 10:50, de vertrektijd" }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Lange reistijd optellen",
            "content": "Vertrek: 10:50. Tel 1 uur erbij: 11:50. Tel dan 20 minuten erbij: 11:50 + 20 min = 12:10.",
            "icon": "lightbulb"
          }
        }
      ],
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "tijd.full-hour-instead-of-minutes", "label": "Alleen de hele uren opgeteld, minuten vergeten", "optionIndex": 1 },
          { "id": "tijd.minutes-addition-error", "label": "Verkeerd aantal minuten opgeteld", "optionIndex": 2 },
          { "id": "tijd.overflow-notation-error", "label": "Minuten boven 60 direct achter dubbele punt geschreven", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "Bij een lange reistijd splits je het optellen in uren en minuten. Eerst 1 uur erbij: 10:50 + 1 uur = 11:50. Dan 20 minuten: 11:50 + 20 min = 12:10 (50 + 20 = 70 min = 1 uur en 10 min).",
        "solutionSteps": ["Vertrektijd: 10:50", "Tel 1 uur erbij: 10:50 + 1 uur = 11:50", "Tel 20 minuten erbij: 11:50 + 20 min = 12:10"],
        "distractorExplanations": {
          "0": "Goed! 10:50 + 1 uur = 11:50, dan + 20 min = 12:10.",
          "1": "Je dacht waarschijnlijk dat je alleen 1 uur hoefde op te tellen. Maar de reistijd is 1 uur én 20 minuten: 10:50 + 1:20 = 12:10, niet 11:10. Onthoud: vergeet de minuten niet.",
          "2": "Je dacht waarschijnlijk dat je 1 uur en 30 minuten moest optellen. Maar de reistijd is 1 uur en 20 minuten, niet 1 uur en 30: 10:50 + 1:20 = 12:10, niet 12:20. Onthoud: lees de reistijd precies.",
          "3": "Je dacht waarschijnlijk dat je gewoon 50 + 20 = 70 achter de dubbele punt kunt schrijven. Maar 11:70 bestaat niet — een uur heeft maar 60 minuten. Onthoud: 70 minuten = 1 uur en 10 minuten, dus 12:10."
        }
      }
    },
    {
      "id": "TIJD-PLANNING-006",
      "familyId": "TIJD-PLANNING",
      "module": "Tijd",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "tijdrekenen",
      "subSkill": "tijd_planning",
      "questionType": "multiple_choice",
      "question": "De trein vertrekt om 14:45. Je moet 20 minuten voor vertrek inchecken en de reis naar het station duurt 30 minuten. Hoe laat vertrek je van huis?",
      "options": ["13:55", "14:05", "14:15", "14:25"],
      "correctAnswer": 0,
      "conceptId": "time_planning_checkin",
      "variantIndex": 6,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.70,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Inchecken en reizen",
            "content": "Trein vertrekt: 14:45. Eerst 20 min voor inchecken: 14:45 − 20 = 14:25. Dan 30 min reistijd: 14:25 − 30 = 13:55. Je vertrekt om 13:55.",
            "icon": "lightbulb"
          }
        },
        {
          "type": "timeline",
          "showWhen": "wrong",
          "data": {
            "label": "Reisplanning naar het station",
            "events": [
              { "position": 13.917, "label": "13:55", "description": "Vertrek huis", "isHighlighted": true },
              { "position": 14.417, "label": "14:25", "description": "Op station (incheck)", "isHighlighted": true },
              { "position": 14.75, "label": "14:45", "description": "Trein vertrekt", "isHighlighted": true }
            ],
            "start": 13.75,
            "end": 15.0
          },
          "a11y": { "alt": "Tijdlijn met vertrek huis 13:55, incheck 14:25, treinvertrek 14:45" }
        }
      ],
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "tijd.buffer-time-forgotten", "label": "Inchecktijd vergeten af te trekken", "optionIndex": 1 },
          { "id": "tijd.cross-hour-only-first-part", "label": "Optelsom van stappen verkeerd over uurgrens", "optionIndex": 2 },
          { "id": "tijd.buffer-time-forgotten", "label": "Reistijd vergeten af te trekken", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "Bij meerdere stappen reken je stap voor stap terug. Eerst trek je de inchecktijd af: 14:45 − 20 min = 14:25. Dan trek je de reistijd naar het station af: 14:25 − 30 min = 13:55. Je vertrekt om 13:55 van huis.",
        "solutionSteps": ["Trein vertrekt: 14:45", "Trek inchecktijd af: 14:45 − 20 min = 14:25", "Trek reistijd af: 14:25 − 30 min = 13:55", "Je vertrekt om 13:55 van huis"],
        "distractorExplanations": {
          "0": "Goed! 14:45 − 20 min = 14:25, dan 14:25 − 30 min = 13:55.",
          "1": "Je dacht waarschijnlijk dat je alleen de reistijd hoefde af te trekken. Maar je vergeet de 20 minuten inchecktijd: 14:45 − 20 − 30 = 13:55, niet 14:05. Onthoud: trek zowel de inchecktijd als de reistijd af.",
          "2": "Je dacht waarschijnlijk dat je alleen de inchecktijd en een deel van de reistijd aftrok. Maar 14:45 − 20 − 30 = 14:45 − 50 = 13:55, niet 14:15. Onthoud: 45 − 50 = −5, dus je gaat 5 minuten voorbij het hele uur: 13:55.",
          "3": "Je dacht waarschijnlijk dat je alleen de inchecktijd hoefde af te trekken. Maar je vergeet de 30 minuten reistijd naar het station: 14:45 − 20 − 30 = 13:55, niet 14:25. Onthoud: trek alle tijdstappen af."
        }
      }
    },
    {
      "id": "TIJD-PLANNING-007",
      "familyId": "TIJD-PLANNING",
      "module": "Tijd",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "tijdrekenen",
      "subSkill": "tijd_planning",
      "questionType": "number_sequence",
      "question": "Vul de ontbrekende tijd in: 09:00, 09:30, __, 10:30",
      "options": ["10:00", "09:45", "10:15", "09:15"],
      "correctAnswer": 0,
      "data": {
        "sequence": ["09:00", "09:30", null, "10:30"],
        "missingIndex": 2,
        "correctValue": "10:00"
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "timeline",
          "showWhen": "wrong",
          "data": {
            "start": 9, "end": 11,
            "events": [
              { "position": 9, "label": "09:00" },
              { "position": 9.5, "label": "09:30" },
              { "position": 10, "label": "10:00", "description": "ontbrekend", "isHighlighted": true },
              { "position": 10.5, "label": "10:30" }
            ],
            "label": "Tijdlijn met stappen van 30 min"
          }
        }
      ],
      "conceptId": "time_pattern_sequence",
      "variantIndex": 7,
      "citoDifficulty": 0.20,
      "citoDiscrimination": 0.76,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "tijd.minutes-addition-error", "label": "Stap-grootte verkeerd berekend (te klein)", "optionIndex": 1 },
          { "id": "tijd.minutes-addition-error", "label": "Stap-grootte verkeerd berekend (te groot)", "optionIndex": 2 },
          { "id": "tijd.add-instead-of-subtract", "label": "Patroon achteruit gelezen i.p.v. vooruit", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "Zoek het patroon door het verschil tussen opeenvolgende tijden te berekenen. 09:00 → 09:30 = +30 minuten. Het patroon is steeds +30 minuten. Dus: 09:30 + 30 min = 10:00. Controleer: 10:00 + 30 min = 10:30 ✓.",
        "solutionSteps": ["Zoek het patroon: 09:00 → 09:30 (stap = +30 minuten)", "Pas toe: 09:30 + 30 min = 10:00", "Controleer: 10:00 + 30 min = 10:30 ✓"],
        "distractorExplanations": {
          "0": "Goed! Elke stap is +30 minuten, dus 09:30 + 30 min = 10:00.",
          "1": "Je dacht waarschijnlijk dat het patroon +15 minuten per stap is. Maar 09:30 − 09:00 = 30 minuten, niet 15. Onthoud: bereken het verschil tussen twee opeenvolgende tijden om het patroon te vinden.",
          "2": "Je dacht waarschijnlijk dat het patroon +45 minuten per stap is. Maar 09:30 − 09:00 = 30 minuten, niet 45. Onthoud: controleer het patroon met meerdere stappen: 10:15 + 30 ≠ 10:30.",
          "3": "Je dacht waarschijnlijk dat de reeks achteruit gaat. Maar de tijden lopen op: 09:00 → 09:30 → ... → 10:30. Na 09:30 komt een later tijdstip, niet een eerder. Onthoud: kijk naar de richting van de reeks."
        }
      }
    }
  ]
}
